import type { WizardOption } from "../../constants/onboardingFallbacks";

export const PROGRAM_LEVEL_OPTIONS_UNIFIED: WizardOption[] = [
  { label: "Bachelors",                     imageUrl: "/icons/degree/school.svg" },
  { label: "Masters",                       imageUrl: "/icons/degree/workspace_premium.svg" },
  { label: "UG/ UG Diploma",                imageUrl: "/icons/degree/workspace_premium.svg" },
  { label: "PG/ PG Diploma",                imageUrl: "/icons/degree/account_balance.svg" },
  { label: "PhD",                           imageUrl: "/icons/degree/cognition_2.svg" },
  { label: "Diploma/ Certificate Programs", imageUrl: "/icons/degree/description.svg" },
  { label: "Foundation/ Pathway Programs",  imageUrl: "/icons/degree/alt_route_ug.svg" },
  { label: "Others",                        imageUrl: "/icons/degree/social_distance.svg" },
];

// CF Study Level IDs → names (source: CF `StudyLevels` table, IsActive = 1):
//   1  = Undergraduate
//   2  = Postgraduate
//   3  = PhD
//   4  = UG Diploma /Certificate /Associate Degree
//   5  = PG Diploma /Certificate
//   8  = High School (11th-12th)
//   9  = Short-term/Summer Programs
//   10 = Grades Below 10th
//   11 = UG+PG (Accelerated) Degree
//   12 = Twinning Programs (UG)
//   13 = Twinning Programs (PG)
//   19 = English Language program (ESL, IEP, ELP)
//   20 = Pathway Programs (UG) (removed)
//   21 = Pathway Programs (PG)(removed)
//   22 = Semester Study Abroad
export const PROGRAM_LEVEL_TO_CF_IDS: Record<string, number[]> = {
  // Simple labels: Bachelors → Undergraduate family, Masters → Postgraduate family.
  Bachelors:                       [1, 11, 12],
  Masters:                         [2, 13],
  "UG/ UG Diploma":                [1, 4, 11, 12],
  "PG/ PG Diploma":                [2, 5, 13],
  PhD:                             [3],
  "Diploma/ Certificate Programs": [4, 5],
  "Foundation/ Pathway Programs":  [19, 20, 21],
  Others:                          [8, 9, 10, 22],
};

// Tie-break order for ids that belong to multiple buckets (4, 5, 20, 21 overlap).
const REVERSE_MAP_PRIORITY: string[] = [
  "PhD",
  "UG/ UG Diploma",
  "PG/ PG Diploma",
  "Foundation/ Pathway Programs",
  "Diploma/ Certificate Programs",
  "Others",
  // New simple labels kept last so existing CF-ID → bucket resolution is unchanged.
  "Bachelors",
  "Masters",
];

// Derived from PROGRAM_LEVEL_TO_CF_IDS + REVERSE_MAP_PRIORITY. Edit those, not this.
export const CF_ID_TO_PROGRAM_LEVEL: Record<number, string> = (() => {
  const reverse: Record<number, string> = {};
  for (const label of REVERSE_MAP_PRIORITY) {
    for (const id of PROGRAM_LEVEL_TO_CF_IDS[label] || []) {
      if (!(id in reverse)) reverse[id] = label;
    }
  }
  return reverse;
})();
